export const getIntegrationCredentialsByOrganization = /* GraphQL */ `
  query GetIntegrationCredentialsByOrganization(
    $organizationId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelIntegrationCredentialsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getIntegrationCredentialsByOrganization(
      organizationId: $organizationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        komboIntegrationId
        organizationId
        provider
        appSubdomain
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
